import { useNavigate, useParams } from "react-router-dom";
import { useGetQuizeQuery } from "../../../features/quize/quizeApi";
import { useGetQuizeMarkQuery } from "../../../features/quizeMark/quizeMarkApi";
import QuizeOption from "./QuizeOption";
import { useSelector } from "react-redux";
import { useEffect } from "react";

export default function Quiz() {
  const { videoId } = useParams();
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const {
    data: quizedata,
    isLoading: quizeLoading,
    isError: quizeError,
  } = useGetQuizeQuery(videoId);

  //quize mark related query
  const { data: quizeMark, isLoading: quizeMarkLoading } = useGetQuizeMarkQuery(
    { videoId: videoId, studentId: user.id }
  );

  const handleOption = (index, event) => {
    console.log(event.target);
  };

  useEffect(() => {
    if (
      !quizeLoading &&
      quizedata.length > 0 &&
      !quizeMarkLoading &&
      quizeMark.length > 0
    ) {
      navigate("/course");
    }
  }, [quizeLoading, quizedata, quizeMark, quizeMarkLoading, navigate]);

  // render quiz
  let content = null;
  if (quizeLoading) content = <p>Loading....</p>;
  if (!quizeLoading && quizeError) content = <p>Error</p>;
  if (!quizeLoading && !quizeError && quizedata)
    content = quizedata.map((quiz, i) => (
      <QuizeOption
        handleOption={handleOption}
        key={i}
        number={i + 1}
        quiz={quiz}
      />
    ));

  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div className="mb-8">
          <h1 className="text-2xl font-bold">
            {quizedata && quizedata[0].video_title}
          </h1>
          <p className="text-sm text-slate-200">
            Each question contains 5 Mark
          </p>
        </div>
        <div className="space-y-8">{content}</div>
        <button className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95">
          Submit
        </button>
      </div>
    </section>
  );
}
